import React from "react"
import { Link } from "react-router-dom"
import { t } from '../../components/i18n/i18n'
import back from "../../assets/images/elements/archiveHeader.jpg"

export const Resources = () => {
  const articles = [
    {
      id: 'bondarenko-pastoral-vocation',
      titleKey: 'resourceArticle1Title',
      authorKey: 'resourceArticle1Author',
      descriptionKey: 'resourceArticle1Description',
      url: '/resources/pastoral-vocation',
    },
    {
      id: 'miroslav-peiter-how-to-know-the-will-of-God',
      titleKey: 'resourceArticle2Title',
      authorKey: 'resourceArticle2Author',
      descriptionKey: 'resourceArticle2Description',
      url: '/resources/the-gods-will',

    }

    // Наступні статті додавайте тут у тому ж форматі
  ]

  return (
    <section className='blog'>
      <div className='container_100'>

        <div className='backImg15'>
          <img src={back} alt='' />
          <div className='text_container_dark_15'>
            <div className='h1_15'>{t("resourcesHeader")}</div>
          </div>
        </div>

        <br />
        <div className='container boxItems'>
            <h1 className='menuColor'>{t("resourcesSubtitle")}</h1>
          <br />
          <div className='grid3'>
            {articles.map((article) => (

              <div className='box boxItems' key={article.id}>
                  <a href={article.url}>
                    <h3 className='menuColor'>{t(article.titleKey)}</h3>
                    <p><em>{t(article.authorKey)}</em></p>
                    <br />
                    <p>{t(article.descriptionKey)}</p>
                    <br />
                  </a>
                <Link to={article.url}>{t("resourceReadMore")}</Link>
              </div>
            ))}
          </div>
        </div>
        <br />
      </div>
    </section>
  )
}
